import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=71b14d1c&"
import script from "./UserDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./UserDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports